import { useEffect, useState } from "react";
import { Button, Label } from "InnoUI/components";
import { Checkbox } from "antd";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { LinkOccupantDropdown, SendTypeDropdown } from "components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  byteToKB,
  byteToMB,
  saveToLocalStorage,
  showAlert,
} from "utils/helper";
import SC from "./style";
import { MAX_FILE_SIZE } from "utils/config";

const SendCart = (props) => {
  const { openModalView, setOpenModalView, files } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ sendToProject: true });
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  const navigate = useNavigate();
  const cartData = useSelector((state) => state.cartData?.data || []);

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );
  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || [],
  );

  const handleChange = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  const handleSend = async () => {
    if (totalFileSize > byteToKB(MAX_FILE_SIZE) && data?.sendType == 4) {
      showAlert({
        title: "Warning",
        text: `File size exceeds ${byteToMB(MAX_FILE_SIZE)} MB. Please select smaller files.`,
        icon: "warning",
      });
      return;
    }

    try {
      if (!data?.sendType) {
        return showAlert({
          title: "Warning",
          text: "Please select send type",
          icon: "warning",
        });
      }
      const sendCartData = {
        occupantId: data.occupantId || [],
        projectId: currentProject?.id || projectId,
        projectType: 0,
        sendToProject: Boolean(data.sendToProject),
        sendType: data.sendType,
        allfileIds: files,
      };
      saveToLocalStorage("sendCartJournalData", sendCartData);
      navigate(`/journal/add-journal?projectId=${currentProject.id}&type=0`);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const handleCancelCompanyModal = () => {
    setOpenModalView(false);
    setData({ sendToProject: true });
  };

  const selctedFileSize =
    files?.length > 0 ? cartData.filter((item) => files.includes(item.id)) : [];

  const totalFileSize = selctedFileSize.reduce(
    (sum, file) => sum + Number(file.fileSize),
    0,
  );

  const RenderModalData = () => {
    return (
      <SC.ModalBody>
        <SC.FormSection>
          <SC.LabelContainer>
            <SC.Label>Select Occupant</SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <LinkOccupantDropdown
                  name="occupantId"
                  type={type}
                  onChange={handleChange}
                  width="100%"
                  maxHeight={"150px"}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>

          <SC.LabelContainer>
            <SC.Label>Project</SC.Label>
            <SC.Children>
              <SC.CheckboxRow>
                <Checkbox
                  checked={Boolean(data?.sendToProject)}
                  onChange={(event) =>
                    handleChange("sendToProject", event.target.checked)
                  }
                >
                  Send to project
                </Checkbox>
              </SC.CheckboxRow>
            </SC.Children>
          </SC.LabelContainer>

          <SC.LabelContainer>
            <SC.Label>
              Select Send Type<SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <SendTypeDropdown name="sendType" onChange={handleChange} />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
        </SC.FormSection>

        <SC.ActionBar>
          <Button
            caption="Cancel"
            onClick={handleCancelCompanyModal}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />

          <Button
            caption={"Send"}
            isLoading={loading}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
            onClick={handleSend}
          />
        </SC.ActionBar>
      </SC.ModalBody>
    );
  };

  return (
    <>
      {openModalView && (
        <BulkActionView
          title={"Send"}
          openModal={openModalView}
          renderBodyConditionally={RenderModalData}
          handleCloseModal={() => {
            setOpenModalView(false);
            setData({ sendToProject: true });
          }}
          sx={{ width: "620px", height: "410px" }}
        />
      )}
    </>
  );
};

export default SendCart;
